import type { ClientContextSource, Me } from '@doughdog/types';

export const AuthStatus = {
	Loading: 'loading',
	Anonymous: 'anonymous',
	Authenticated: 'authenticated',
} as const;

export type AuthState =
	| { status: typeof AuthStatus.Loading }
	| { status: typeof AuthStatus.Anonymous }
	| { status: typeof AuthStatus.Authenticated; source: ClientContextSource; me: Me };
